import { useEffect, useMemo, useState } from 'react';

import { ForumIcon, GroupIcon, NotificationsIcon, TagIcon } from '@orijinworks/frontend-commons';

export const useFeedConfigureHook = (props) => {
  const {
    unreadCount,
    unreadAnnouncementsCount,
    unreadMessagesCount,
  } = props;

  const [showNewMessageModal, setShowNewMessageModal] = useState(false);
  const [modalContext, setModalContext] = useState('');
  const [editSettings, setEditSettings] = useState(null);


  // Event handlers
  const handleNewMessage = (context) => {
    setShowNewMessageModal(true);
    setModalContext(context);
  };

  const handleCloseModal = () => {
    setShowNewMessageModal(false);
  };

  const handleOpenEditModal = (settings) => {
    setEditSettings(settings || null);
    setShowNewMessageModal(true);
    setModalContext('edit');
  };

  // Computed values
  const allCount = unreadCount || 0;

  // Tab configuration data
  const tabsConfig = useMemo(() => {
    return [
      {
        key: 'all',
        label: 'All',
        value: 'All',
        Icon: ForumIcon,
        hasUnreadCount: (allCount ?? 0) > 0,
        unreadCount: allCount,
        hide: true,
      },
      {
        key: 'messages',
        label: 'Messages',
        value: 'Messages',
        Icon: GroupIcon,
        hasUnreadCount: (unreadMessagesCount ?? 0) > 0,
        unreadCount: unreadMessagesCount || 0,
        hide:false

      },
      {
        key: 'announcements',
        label: 'Announcements',
        value: 'Announcements',
        Icon: NotificationsIcon,
        hasUnreadCount: (unreadAnnouncementsCount ?? 0) > 0,
        unreadCount: unreadAnnouncementsCount ?? 0,
        hide:false
      },
    ]
  }, [allCount, unreadAnnouncementsCount, unreadMessagesCount]);

  const onTabChangeHandler = (event, value) => {
    props.onTabChangeHandler && props.onTabChangeHandler(event, value);
  };
  return {
    // State
    showNewMessageModal,
    modalContext,
    editSettings,

    // Computed values
    tabsConfig,
    allCount,

    // Event handlers
    handleNewMessage,
    handleCloseModal,
    handleOpenEditModal,
    onTabChangeHandler,
  };
};